<template>
    <!-- Breadcrumb container -->
    <div :class="['flex items-center gap-2 z-10 p-2 bg-[#f1f6fa]/80 backdrop-blur-sm border-b border-gray-200 dark:border-neutral-700', sticky ? 'sticky top-0' : '']">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'Path',
    props: {
        sticky: {
            type: Boolean,
            default: false
        }
    }
};
</script>
